<template >
  <sc-panel-navigator
      ref="sidePanel"
      :drawer-width="drawerWidth"
      :content-drawable="true"
      :enable="$mobileDevice"
      :backdrop="false"
      :z-index="0"
      @slide-end="handleContentFrame"
      @slide-move="handleContentFrame" >
    <div

        class="drawer-content"
        style="border: 1px solid white" >
      <el-row
          xgutter="20"
          xstyle="padding: 20px" >

        <el-col :md="$userProfile.invoiceGroups ? 20 : 24" >
          <el-radio-group
              v-model="selectedSira"
              fill="green"
              class="invoice-options"
              @change="displaySums();routeGo({ query: { kind: selectedSira } })" >
            <el-radio-button label="invoice" >{{ $t('Τιμολόγια') }}</el-radio-button >
            <el-radio-button label="receipt" >{{ $t('ΑΠΥ') }}</el-radio-button >
            <el-radio-button label="pistotiko" >{{ $t('Πιστωτικά') }}</el-radio-button >
          </el-radio-group >
          <el-checkbox v-model="onlyCanceled" >Only Canceled</el-checkbox >
        </el-col >
        <el-col
            v-if="$userProfile.invoiceGroups"
            :md="4"
            style="margin-bottom: 15px" >
          <el-select
              v-model="selectedTimoGroup"
              placeholder="Select"
              style="width: 100%"
              @change="displaySums();" >
            <el-option
                v-for="(groupLabel, groupId) in $userProfile.invoiceGroups"
                :key="groupId"
                :label="groupLabel"
                :value="groupId" ></el-option >
          </el-select >
        </el-col >
        <el-col
            :md="24"
            style="margin-bottom: 15px" >
          <el-input
              v-model="searchBusiness"
              :placeholder="$t('Όνομα, ΑΦΜ, Περιγραφή...')"
              @input="displaySums()"
              clearable ></el-input >
        </el-col >
        <el-col :md="24" >
          <!-- =={{dateRange}}== -->
          <ctk-dater
              default="4months"
              v-model="dateRange"
              range-by-seprator="-"
              range

              export-format="dd/mm/yy"
              @input="displaySums()"
              :customise-shortcuts="dtshorts" ></ctk-dater >
          <!-- <r-dater v-model="dateRange"></r-dater> -->
        </el-col >

      </el-row >
      <el-row >
        <el-menu
            default-active="all"
            mode="horizontal"
            background-color="#009688"
            text-color="#fff"
            active-text-color="#ffd04b"
            @select="selectInvoiceState" >
          <el-menu-item index="all" >
            <i class="far fa-file-alt" ></i >
            <span v-if="!isMobileDevice()" >{{ $t('Όλα') }}</span >
          </el-menu-item >

          <el-menu-item index="issed" >
            <i class="fas fa-file-invoice" ></i >
            <span v-if="!isMobileDevice()" >{{ $t('Εκδομένα') }}</span >
          </el-menu-item >
          <el-menu-item index="notIssued" >
            <i class="fas fa-pencil-ruler" ></i >
            <span v-if="!isMobileDevice()" >{{ $t('Πρόχειρα') }}</span >
          </el-menu-item >
          <el-menu-item index="gadgets" >
            <i
                class="material-icons"
                style="color: #fff" >functions</i > <i
              class="material-icons"
              style="color: #fff" >share</i >
          </el-menu-item >
        </el-menu >
      </el-row >
      <el-row >
        <s-table
            v-if="loaded"
            :key="clock"
            v-model="listedInvoices"
            default-sort="aa"
            :top-offset="140"
            row-key-field="timologioId"
            xheight-wish="tobo"
            :selection-id="selectedInvoice ? selectedInvoice.timologioId : null"
            ref="listedInvoices"
            :col-definitions="colDefinitions"
            modx-processor="timologio/getlist"
            :r-query="qInvoices"
            :row-class-factory="invoiceListClass"
            xwake-up-path="timologiera"
            simple-lazy-loader
            :mobileMode="isMobileDevice()"
            @cell-clicked="loadInvoice" ></s-table >
      </el-row >
    </div >
    <div slot="body" >
      <div
          class="dark dark-header"
          v-loading="processing"
          style="width:99%" >


        <el-row
            class="actions_btns"
            type="flex"
            xjustify="center" >
          <el-button
              v-if="$userProfile.canIssueManually"
              size="small"
              type="success"
              style="padding: 10px;margin-right: 5px;"
              @click="
                routeGo({
                name: 'ManageInvoice',
                params: { id: 'new' },
                });
                $refs['businessDetails'].focus();
              " >
            <fa
                icon="plus-square"
                fixed-width
                size="lg" ></fa >
            <!--            <i class="fas fa-plus-square" ></i >-->
          </el-button >
          <s-responsive-panel
              :go-responsive="1320"
              toast-icon="cog" >


            <el-button
                size="small"
                v-if="selectedInvoice.timologioId&&$userProfile.canIssueManually"
                type="warning"
                :disabled="!!selectedInvoice.aade_uid&&selectedInvoice.aade_uid!='error'"
                @click="canEdit = !canEdit" >

              <fa
                  icon="pencil-alt"
                  fixed-width
                  size="lg" ></fa >
            </el-button >

            <template
                v-if="selectedInvoice.aa && selectedInvoice.aa > 0"
                class="text-center round_btn_left"
                style="width: 120px" >
              <el-button
                  xdisabled="!!selectedInvoice.aade_uid"
                  type="danger"

                  plain
                  @click="cancelInvoice()" >
                <fa
                    :icon="selectedInvoice.canceled != 1?'ban':'redo-alt'"
                    fixed-width
                    size="lg" ></fa >
                <!--                <i-->
                <!--                    v-if="selectedInvoice.canceled != 1"-->
                <!--                    class="fas fa-ban" ></i > <i-->
                <!--                  v-else-->
                <!--                  class="fas fa-redo-alt" ></i >-->
              </el-button >

              <!--              <el-button-->
              <!--                  type="success"-->
              <!--                  size="small"-->
              <!--                 -->
              <!--                  v-if="selectedInvoice.canceled != 1"-->
              <!--                  plain-->
              <!--                  @click="handlePayment()" >-->
              <!--                <i-->
              <!--                    v-if="selectedInvoice.payed == 1"-->
              <!--                    class="far fa-thumbs-up" ></i > <i class="fas fa-euro-sign" ></i >-->
              <!--              </el-button >-->


            </template >
            <el-button

                v-if="isWindowSize('sm')"
                class="print_btn"
                @click="printerLang = printerLang == 'gr' ? 'en' : 'gr'" >{{ printerLang == "gr" ? "Ελ" : "En" }}
            </el-button >
            <el-button
                v-if="isWindowSize('sm')"
                type="success" >
              <a
                  target="_blank"
                  class="print_btn"
                  :title="$t('εκτύπωση')"
                  :href="printLink" >
                <i class="fas fa-print" ></i >
              </a >
            </el-button >

            <el-button
                v-if="$userProfile.canIssueManually&&selectedInvoice.timologioId&&selectedInvoice.canceled != 1"
                type="warning"
                plain
                :title="$t('Αντίγραψε αυτό το παραστατικό')"
                @click="copyInvoice()" >
              <fa
                  icon="copy"
                  fixed-width
                  size="lg" ></fa >

            </el-button >

            <el-button
                v-if="selectedInvoice.timologioId&&$userProfile.canIssueManually&&selectedInvoice.canceled != 1"
                type="danger"
                plain
                :disabled="!canEdit"
                :title="$t('Μεταφορά των εγγραφών αυτού του παραστατικού σε άλλο')"
                @click="moveTransactions()" >
              <fa icon="arrows-alt" ></fa >
            </el-button >
            <!--            &&$userProfile.canIssueManually-->
            <el-button
                v-if="selectedInvoice.timologioId"
                type="danger"
                :disabled="!!selectedInvoice.aade_uid"
                plain
                icon="el-icon-delete"
                @click="deleteInvoice()" >

            </el-button >
            <el-button
                v-if="selectedInvoice.timologioId"
                type="success"
                size="small"

                plain
                xicon="el-icon-s-check"
                @click="aadeErrors=null;showAadeControl=true" >
              <span style="    font-size: 12px;    font-weight: bolder;" >
                ΑΑΔΕ
              </span >
            </el-button >
          </s-responsive-panel >

          <el-col
              v-if="selectedInvoice.timologioId"
              :sm="24"
              :xs="8"
              class="text-right" >
            <el-button
                v-if="!isWindowSize('sm')"
                type="text"
                round
                style="box-shadow: 0px 0px 1px"
                @click="printerLang = printerLang == 'gr' ? 'en' : 'gr'" >{{ printerLang == "gr" ? "Ελ" : "En" }}
            </el-button >
            <!--            <el-button-->
            <!--                v-if="!isWindowSize('sm')"-->
            <!--                type="success" >-->
            <a
                v-if="!isWindowSize('sm')"
                target="_blank"
                class="print_btn"
                style="background-color: #6ebf48;padding: 10px;color: #095b69;border-radius: 1pc; box-shadow: 0px 0px 0px 3px;"
                :title="$t('εκτύπωση')"
                :href="printLink" >
              <fa
                  icon="print"
                  fixed-width
                  size="lg" ></fa >
            </a >
            <el-button
                :title="$t(aggregators.cost?'Έκδωσε το παραστατικό (θα πάρει αυξον αριθμό)':'Δεν υπάρχουν χρεώσεις για να εκδωθεί')"
                v-if="!selectedInvoice.aa"
                type="primary"
                :disabled="!aggregators.cost"
                style="width: 120px;height: 37px;margin-left: 5px;"
                @click="issueInvoice()" >
              <fa
                  icon="clipboard-check"
                  fixed-width
                  size="lg" ></fa >
              ΕΚΔΩΣΗ
              <div

                  style="font-size: 10px; padding: 2px; line-height: 10px;" >{{ $t(lexicon[selectedInvoice.kind]) }}
              </div >

            </el-button >
            <div
                class="stamp"
                v-else >
              <el-row
                  class="boxed pl"
                  type="flex"
                  justify="space-between" >
                <div

                    style="width: 120px;float: right;font-size: 10px; padding: 2px; line-height: 10px;" >

                  <div style="overflow: hidden;     width: 109px; float: left" >
                    {{ $t(lexicon[selectedInvoice.kind]) }}:{{ $userProfile.invoiceGroups[selectedInvoice.timo_group] }}
                  </div >
                  <div
                      class="outline-text"
                      style="padding-left: 2px;padding-right:2px "
                      v-if="selectedInvoice.aa && selectedInvoice.aa > 0" >{{ selectedInvoice.aa }}
                  </div >
                </div >
                <div >
                  <el-button
                      :title="selectedInvoice.aade_uid&&selectedInvoice.aade_uid!='error'?'Εχει αποστασλεί στην ΑΑΔΕ':'Αποστολή στην ΑΑΔΕ τώρα'"
                      :plain="selectedInvoice.aade_uid&&selectedInvoice.aade_uid!='error'?false:true"
                      cdisabled="!!selectedInvoice.aade_uid&&selectedInvoice.aade_uid!='error'"
                      style="width: 30px;height: 30px"
                      :type="selectedInvoice.aade_uid&&selectedInvoice.aade_uid!='error'?'success':'warning'"
                      v-if="selectedInvoice.timo_group!='E'&&selectedInvoice.aa&&selectedInvoice.kind!= 'pay_receipt'"
                      @click="exportAADE(true)" >
                    <fa
                        icon="arrow-circle-up"
                        fixed-width
                        style="font-size: 2em"
                        size="lg" ></fa >
                    <!--                    <i class="fa-lg fab fa-expeditedssl" ></i >-->
                  </el-button >


                </div >

              </el-row >
            </div >
          </el-col >
        </el-row >
        <!-- <p>{{$route.params}}</p> -->
        <el-row >
          <BuisnessPanel
              v-show="$route.params.id == 'new' || selectedInvoice.timologioId"
              ref="businessDetails"

              :disabled="!canEdit"
              :search-string="selectedInvoice.business_name"
              :confirm-update="
              selectedInvoice.aa != null && selectedInvoice.aa != ''
            "
              :business-id="selectedInvoice.businessId"
              embed-mode
              @businessChange="changeBusiness" ></BuisnessPanel >
        </el-row >

        <el-card
            v-if="selectedInvoice.timologioId"
            shadow="always"
            style="overflow: visible" >
          <el-row
              slot="header"
              class="clearfix"
              :gutter="5" >
            <el-col
                :sm="8"
                :xs="24" >

              <q-input
                  filled
                  v-model="selectedInvoice.date"
                  xmask="date"
                  xrules="['date']"
                  dense
                  :disable="!canEdit"
                  @input="updateInvoice()" >
                <template v-slot:append >
                  <q-icon
                      name="event"
                      class="cursor-pointer" >
                    <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale" >
                      <q-date
                          v-model="selectedInvoice.date"
                          minimal
                          mask="DD/MM/YYYY"
                          @input="$refs.qDateProxy.hide(); updateInvoice()" >
                        <div class="row items-center justify-end" >
                          <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat />
                        </div >
                      </q-date >
                    </q-popup-proxy >
                  </q-icon >
                </template >
              </q-input >

            </el-col >

            <el-col
                :sm="8"
                :xs="24" >
              <el-row >
                <el-col :span="6" >{{ $t('ΦΠΑ') }}%</el-col >
                <el-col :span="18" >
                  <s-number
                      v-model="selectedInvoice.vat"
                      :disabled="!canEdit||!$userProfile.canIssueManually" />
                </el-col >
              </el-row >
              <!--              <el-select-->
              <!--                  v-model="selectedInvoice.aade_options.vatCategory"-->
              <!--                  placeholder="Select"-->

              <!--                  :disabled="!canEdit"-->
              <!--                  @input="updateInvoice(null,false,true)"-->
              <!--                  style="width: 100px;" >-->
              <!--                <el-option-->
              <!--                    v-for="item in vatCatOptions"-->
              <!--                    :key="item.value"-->
              <!--                    :label="item.label"-->
              <!--                    :value="item.value" ></el-option >-->
              <!--              </el-select >-->
            </el-col >
            <!--            <el-col-->
            <!--                :sm="9"-->
            <!--                :xs="15" >-->
            <!--              <el-input-->
            <!--                  v-model="selectedInvoice.place"-->
            <!--                  :disabled="!canEdit" >-->
            <!--                <template slot="prepend" >-->
            <!--                  <i class="material-icons" >room</i >-->
            <!--                </template >-->
            <!--              </el-input >-->
            <!--            </el-col >-->

            <el-col
                :sm="8"
                :xs="24"
                title="Παρακράτηση φόρου" >
              <el-input
                  v-model="selectedInvoice.tax"
                  :disabled="!canEdit"
                  @input="updateInvoice(null, true)" >
                <template slot="prepend" >
                  <fa icon="archways" ></fa >
                </template >
                <template
                    slot="append" >%
                </template >
              </el-input >
            </el-col >
          </el-row >

          <s-responsive-panel
              :go-responsive="1020"
              :caption="'Σ:'+$theMoney(aggregators.costincl) + '&euro;'"
              style="margin: 10px" >
            <el-col :sm="8" >
              <span >
                <small >{{ $t('καθ. αξία') }}</small >
                {{ $theMoney(aggregators.cost) }}&euro;
              </span >
            </el-col >
            <el-col :sm="8" >
              <span >
                <small >{{ $t('φ.π.α.') }}</small >
                {{ $theMoney(aggregators.costincl - aggregators.cost) }}&euro;
              </span >
            </el-col >
            <el-col :sm="8" >
              <span >
                <small >{{ $t('αξία') }}</small >
                {{ $theMoney(aggregators.costincl) }}&euro;
              </span >
            </el-col >
          </s-responsive-panel >
        </el-card >
        <div
            v-else
            class="dark"
            append-to-body
            round
            style="padding: 5px;"
            title="SUMS"
            position="right"
            direction="rtl"
            size="100%"
            :visible.sync="showSums"
            get-container="#app" >
          <el-row
              v-for="(Sum, idx) in Sums"
              :key="idx"
              style="border-bottom:1px wheat dashed " >
            <el-col
                :md="4"
                :xs="24" >
              <h4 style="text-align: center" >
                {{ Sum.kind == "receipt" ? $t('ΑΠΥ') : "" }}{{
                  Sum.kind == "invoice" ? $t('ΤΙΜΟΛΟΓΙΑ') : ""
                }}{{ Sum.kind == "pistotiko" ? $t('ΠΙΣΤΩΤΙΚΑ') : "" }}
                <small >
                  σ: {{ Sum.timo_group }}
                </small >
              </h4 >
            </el-col >
            <el-col
                :md="10"
                :xs="24" >
              <div >
                <h4 class="text-center" >{{ $t('Σύνολα χρεώσεων') }}</h4 >

                <h3 class="text-center" >
                  <i class="material-icons" >functions</i > {{ Sum.total }}

                  <small >+{{ $t('ΦΠΑ') }}:</small >
                                                            {{ Sum.totalvat }} ={{ Sum.totalall }}
                </h3 >
              </div >
            </el-col >
            <el-col
                :md="10"
                :xs="24" >
              <div >
                <h4 class="text-center" >{{ $t('Σύνολα πληρωμών') }}</h4 >
                <h3 class="text-center" >
                  <el-col :md="12" >
                    <small >{{ $t('Εξοφλημένα') }}:</small >
                    {{ Sum.totalpayed }}&nbsp;
                  </el-col >
                  <el-col :md="12" >
                    <small >{{ $t('Ανεξόφλητα') }}:</small >
                    {{ Sum.totalnotpayed }}
                  </el-col >
                </h3 >
              </div >
            </el-col >
          </el-row >

          <el-row style="padding:15px" >
            <el-col :md="24" >
              <s-action-pannel >
                <el-button
                    slot="actions"
                    type="primary"
                    plain
                    @click="exportEXCEL()" >
                  <i class="material-icons" >file_download</i >
                </el-button >
                <span >{{ $t('Λήψη ') }} (excel) για τύπο παραστατικών <strong > {{
                    $t(lexicon[$route.query.kind])
                                                                                 }}.{{
                    $userProfile.invoiceGroups[$route.query.selectedTimoGroup]
                                                                                 }}</strong ></span >
              </s-action-pannel >
            </el-col >
            <!--            <el-col :md="12" >-->
            <!--              <s-action-pannel >-->
            <!--                <el-button-->
            <!--                    slot="actions"-->
            <!--                    type="primary"-->
            <!--                    plain-->
            <!--                    @click="exportEXCEL('grouped')" >-->
            <!--                  <i class="material-icons" >perm_identity</i > <i class="material-icons" >file_download</i >-->
            <!--                </el-button >-->
            <!--                <span >{{ $t('Λήψη ΜΥΦ') }} (excel)</span >-->
            <!--              </s-action-pannel >-->
            <!--            </el-col >-->

          </el-row >
          <!--          <el-row >-->
          <!--            <s-action-pannel v-if="qInvoices.searchdaterange&&!!qInvoices.searchdaterange[0]&&!!qInvoices.searchdaterange[1]" >-->
          <!--              <s-button-->
          <!--                  confirm="Είσθε σίγουρος οτι θελετε να στείλετε (ακόμα και αυτά που εχουν σταλεί) στην ΑΑΔΕ?"-->
          <!--                  @execute="exportAADE()"-->
          <!--                  slot="actions"-->
          <!--                  type="success"-->
          <!--                  plain >-->
          <!--                <i class="material-icons" >forward_to_inbox</i >-->
          <!--              </s-button >-->
          <!--              <span >{{ $t('Αποστολή όλων των επιλεγμένων παραστατικών στην ΑΑΔΕ') }}</span >-->
          <!--            </s-action-pannel >-->
          <!--          </el-row >-->
          <el-card v-if="aadeMsgs" >


            <h4 slot="header" >
              <el-row :gutter="10" >
                {{ aadeMsgs }}
                <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    icon="el-icon-close"
                    @click="aadeMsgs=null" ></el-button >
              </el-row >
            </h4 >
            <div
                style="height: 50vh; overflow: auto"
                v-if="aadeErrors && aadeErrors.length" >
              <el-row
                  v-for="invEr in aadeErrors"
                  :key="invEr.inv_id"
                  :gutter="10" >
                <el-col :span="6" >
                  <el-button
                      @click="showSums=false;loadInvoice(invEr.inv_id)" >
                    {{ invEr.aa }}
                  </el-button >
                </el-col >
                <el-col :span="18" >
                  {{ invEr.msg }}

                </el-col >
              </el-row >
            </div >
          </el-card >
        </div >
        <!-- <h4 v-else class="quoted dark" style="text-align:center">Παρακαλώ επιλέξτε πελάτη</h4> -->
        <el-row v-if="selectedInvoice.timologioId" >
          <el-tabs
              v-model="actTab"
              tab-position="left"
              style="height: 100%" >
            <el-tab-pane
                key="main"

                name="main" >
              <span
                  slot="label"
                  title="Σχόλια στο παραστατικό" >
                <fa
                    icon="clipboard-list"
                    class="fas fa-clipboard-list"
                    :title="
                    useItAsTransDescription
                      ? $t('περιγραφή στο παραστατικό')
                      : $t('σχόλιο παραστατικού')
                  " ></fa >
              </span >

              <emb-drafts-table
                  invoice-mode
                  :key="canEdit?1:2"
                  v-model="selectedInvoice"
                  :allow-edit="$userProfile.canIssueManually&&canEdit"
                  @transctionsChanged="updateCosts" ></emb-drafts-table >
              <!--              <transactions-panel-->
              <!--                  v-if="actTab=='main'"-->
              <!--                  :key="transactionsClock"-->
              <!--                  :disabled="!canEdit"-->
              <!--                  :invoice-data="selectedInvoice"-->
              <!--                  :business-id="selectedInvoice.businessId"-->
              <!--                  @transctionsChanged="updateCosts" ></transactions-panel >-->

            </el-tab-pane >
            <el-tab-pane
                key="comments"

                name="comments" >
              <span
                  slot="label"
                  title="Σχολια" >
                <fa icon="comment-alt" ></fa >
              </span >

              <el-row >
                <el-input
                    v-model="selectedInvoice.comments"
                    xdisabled="!canEdit"
                    type="textarea"
                    :rows="5"
                    :placeholder="$t('σχόλιο/περιγραφή')"
                    @input="updateInvoice(null, true)" ></el-input >
                <el-alert
                    type="success"
                    :closable="false" >
                  <p >{{ $t('Στην εκτύπωση θα χρησιμοποιηθεί ως ') }}</p >

                  <el-switch
                      v-model="useItAsTransDescription"
                      :disabled="!canEdit"
                      :active-text="$t('περιγραφή στο παραστατικό')"
                      :inactive-text="$t('απλό σχόλιο')" ></el-switch >
                </el-alert >
              </el-row >

            </el-tab-pane >
            <!--            <el-tab-pane-->
            <!--                key="transdrafts"-->

            <!--                name="transdrafts" >-->
            <!--              <span slot="label" >-->
            <!--               <fa icon="cash-register" ></fa >-->
            <!--              </span >-->


            <!--              <el-row >-->

            <!--                <emb-drafts-table-->
            <!--                    v-if="actTab=='transdrafts'"-->
            <!--                    :key="clock"-->
            <!--                    del-button-->
            <!--                    :nav-button="false"-->
            <!--                    type="payment"-->
            <!--                    :is-income="true"-->
            <!--                    v-model="selectedInvoice" ></emb-drafts-table >-->
            <!--              </el-row >-->
            <!--            </el-tab-pane >-->
          </el-tabs >

        </el-row >
      </div >
      <el-drawer
          class="dark"
          append-to-body
          round
          :title="'ΤΑΥΤΟΤΗΤΑ ΑΑΔΕ : '+selectedInvoice.aade_uid"
          position="right"
          direction="rtl"
          size="100%"
          :visible.sync="showAadeControl"
          get-container="#app" >

        <div v-if="aadeErrors&&aadeErrors.length" >
          <h3 >Last errors</h3 >
          <pre >{{ aadeErrors }}</pre >
        </div >
        <AADEHandler

            :selected-invoice="selectedInvoice"
            :key="selectedInvoice?selectedInvoice.timologioId:0" />
      </el-drawer >

    </div >

  </sc-panel-navigator >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";
import {async} from "q";
import ResponsivePanel from "../Form/ResponsivePanel";
import EmbDraftsTable from "../Form/EmbDraftsTable";
import SButton from "../../Form/SButton";
import AADEHandler from "./AADEHandler";
import SNumber from "../Form/Number";
import BuisnessPanel from "../Form/BuisnessPanel";

export default {
  components: {BuisnessPanel, SNumber, AADEHandler, EmbDraftsTable},
  data() {
    return {
      onlyCanceled: false,
      showAadeControl: false,
      tabMode: 'transactions',
      actTab: 'main',
      selectedMark: null,
      aadeReport: null,
      transDraftsMode: true,
      aadeMsgs: null,
      transactionsClock: 0,
      showSums: false,
      aadeErrors: null,
      clock: 1,
      Sums: [],
      dtshorts: [
        {key: "lastWeek", label: "Πργ. Εβδομ."},
        {key: "thisWeek", label: "Τρχ. Εβδομ."},

        {
          key: "nextWeek",
          label: "Επμ. Εβδομ."
        },
        // { key: "last7Days", label: "Last 7 days", value: 7 },
        // { key: "last30Days", label: "Last 30 days", value: 30 },
        {key: "lastMonth", label: "Πργ. Μήνας"},
        {key: "thisMonth", label: "Τρχ. Μηνας"},

        {
          key: "nextMonth",
          label: "Επμ. Μηνας"
        },
        {key: "lastYear", label: "Πργ. Ετος"},
        {key: "thisYear", label: "Φέτος"}
      ],
      selectedSira: "receipt",
      // selectedTimoGroup: null,
      selectedInvoiceToMoveTrans: null,
      useItAsTransDescription: false,
      showDetails: false,
      workingBusiness: null,
      drawerIsOpen: true,
      searchBusiness: null,
      searchTransactions: null,
      invoiceState: "all",
      dateRange: [],
      listedInvoices: [],
      selectedInvoice: {},
      canEdit: true,
      aggregators: {
        cost: 0,
        costincl: 0
      },
      contentFrame: "width:calc(100vw - 700px);",
      drawerWidth: window.innerWidth < 500 ? window.innerWidth : 500,
      loaded: false,
      processing: false,
      userProfile: UserProfile,
      printerLang: "gr",
      dateFormat: "DD/MM/YY"
    };
  },
  computed: {
    selectedTimoGroup: {
      set(v) {
        // _log_("go ahead/bookingRange/", v);
        // if (this.loading) return;
        let q = JSON.parse(JSON.stringify(this.$route.query));
        if (!v) {
          v = q.selectedTimoGroup ? q.selectedTimoGroup : 'A';

        }
        if (q.selectedTimoGroup == v) return
        q.selectedTimoGroup = v;
        this.routeGo(
            {
              query: q,
            },
            true
        );

        return;
      },
      get() {
        // _log_("go ahead/bookingRange/", this.$route.query);

        return this.$route.query.selectedTimoGroup ? this.$route.query.selectedTimoGroup : 'A'
      },
    },
    printLink() {
      return this.$userProfile.printers[this.selectedInvoice.kind] ? (this.$userProfile.printers[this.selectedInvoice.kind].default + this.selectedInvoice.timologioId) : null


    },
    range: {
      set(range) {
        this.$store.commit("dateRange", range);
      },
      get(range) {
        return this.$store.state.dateRange;
      }
    },
    // qInvoices() {
    //   return {
    //     sort: "aa",
    //     dir: "DESC",
    //     // sira: "invoice",
    //     issue_state: this.invoiceState,
    //     sira: this.selectedSira,
    //     timo_group: this.selectedTimoGroup ? this.selectedTimoGroup : "Α",
    //     search: this.searchBusiness,
    //     searchdaterange:
    //         this.$dateRangeArr && this.$dateRangeArr[0] && this.$dateRangeArr[1]
    //             ? this.$dateRangeArr[0] + "-" + this.$dateRangeArr[1]
    //             : null
    //   };
    // },
    qInvoices() {
      return {
        sort: "aa",
        dir: "DESC",
        // sira: "invoice",
        issue_state: this.invoiceState,
        sira: this.selectedSira,
        onlyCanceled: this.onlyCanceled,
        timo_group: this.selectedTimoGroup ? this.selectedTimoGroup : "Α",
        search: this.searchBusiness,
        searchdaterange:
            this.dateRange && this.dateRange[0] && this.dateRange[1]
                ? this.dateRange[0] + "-" + this.dateRange[1]
                : null
      };
    },
    colDefinitions() {
      const vm = this
      return [
        //  {
        //   prop: "idx",
        //   width: "",
        //   label: "i."
        //  },
        // {
        //   prop: "aa",
        //   width: "",
        //   label: "Α.Α.",
        //   mLabel: "",
        //   formatter(val, colDefs, row, vm) {
        //     if (val == 0) return "";
        //     if (row.aade_uid) {
        //       if (row.aade_uid != 'error') val =
        //           '<i class="fas fa-lock"></i>' +
        //           val;
        //       if (row.aade_uid == 'error') val += '<i title="Η αποστολη στην ΑΑΔΕ απέτυχε" style="color: #ff5100" class="fas fa-exclamation"></i>'
        //       else if (!row.aade_marks) val += '<i title="Εχει αφαιρεθεί μέσα απο την ΑΑΔΕ" style="color: #ff5100" class="fas fa-exclamation"></i>'
        //       else {
        //         const lastMark = row.aade_marks[row.aade_marks.length - 1], isCanceled = lastMark[0] == '!'
        //         if (row.canceled && !isCanceled) val += '<i title="Δεν είναι ενήμερη η ΑΑΔΕ οτι έχει ακυρωθεί το παραστατικό" style="color: #ff5100" class="fas fa-exclamation"></i>'
        //         if (!row.canceled && isCanceled) val += '<i title="Η ΑΑΔΕ πιστεύει οτι έχει ακυρωθεί το παραστατικό" style="color: #ff5100" class="fas fa-exclamation"></i>'
        //       }
        //     }
        //     else val =
        //         '<i class="fas fa-lock-open" title="' + vm.$t('Δεν εχει αποσταλεί στην ΑΑΔΕ') + '"></i>' +
        //         val;
        //     val += (row.payed ? '<i class="fas fa-thumbs-up"></i>' : "")
        //     return (
        //         '<span style="float:left" class="invoice-tag ' +
        //         (row.canceled == 1 ? "canceled" : "normal") + (!row.aade_uid || row.aade_uid == 'error' ? ' notaade' : '') +
        //         '">' +
        //         val +
        //         "</span>"
        //
        //     )
        //         ;
        //   }
        // },
        {
          prop: "aa",
          width: "",
          label: "Α.Α.",
          mLabel: "",
          formatter(val, colDefs, row) {
            if (val == 0) return "";
            if (row.aade_uid)
              val =
                  '<i class=" fab fa-expeditedssl"></i>' +
                  val;
            val += (row.payed ? '<i class="far fa-thumbs-up"></i>' : "")
            if (!row.aade_marks) val += '!!'
            else
              val += !row.aade_marks.length ? '!!!' : ''
            return (
                '<span style="float:left;background-color:transparent;" class="el-tag el-tag--' +
                (row.canceled == 1 ? "danger" : "success") +
                ' el-tag--light">' +
                val +
                "</span>"

            );
          }
        },
        {mLabel: "", prop: "date", width: "90px", label: "Ημ/νια"},
        {mLabel: "", prop: "business_name", width: "200px", label: "Πελατης"},

        // {
        //   prop: "cost",
        //   width: "100px",
        //   label: "Κοστος",
        //   formatter(val, colDefs, row) {
        //     if (val) return parseFloat(val).formatMoney(2) + "&euro;";
        //     return "-";
        //   }
        // },

        {
          mLabel: "",
          prop: "costwithvat",
          width: "100px",
          label: vm.$t("Συνολο"),
          formatter(val, colDefs, row) {

            val = row.kind != 'dept' && row.kind != 'invoice' && row.kind != 'receipt' && row.kind != 'pistotiko' ? row.drafts_payed : row.drafts_cost
            if (val) return parseFloat(Math.abs(val))
                .formatMoney(2) + "&euro;";
            return "-";
          }
        }
      ];
    }
  },
  watch: {

    "selectedInvoice.print_type"(val, oldvl) {
      if (val == oldvl) return;
      if (this.selectedInvoice.print_type == "compact")
        this.useItAsTransDescription = true;
      else this.useItAsTransDescription = false;
    },
    useItAsTransDescription(val, oldvl) {
      if (val == oldvl) return;
      if (val === true) this.selectedInvoice.print_type = "compact";
      else this.selectedInvoice.print_type = "normal";
      this.updateInvoice(null, true);
    },
    "$route.query.kind"(v, vo) {
      if (!v) return;
      _log_("oe.SRR..", v, vo);
      if (v == vo) return;
      if (this.selectedSira != this.$route.query.kind)
        this.selectedSira = this.$route.query.kind;
    },
    "$route.name": {
      handler: async function (nm, nmold) {
        _log_("rrrole.11..." + nm, this.$route.params.id);
        if (nm == nmold) return;
        if (nm == "timologiera" || nm == "timologio")
          if (!this.$route.params.id) this.selectedInvoice = {};
      },
      deep: true,
      immediate: true
    },
    "$route.params.id": {
      handler: async function (timid, oldid) {
        _log_("rrrole.11...", timid);
        if (this.$route.name != "ManageInvoice") return;
        if (!timid || timid == oldid || timid == "all") return;
        if (!timid) {
          this.selectedInvoice = {};
          return;
        }

        if (timid == "new") {
          this.newInvoice();
          return;
        }
        var {data} = await api.fetchProcessor("timologio/get", {
          timologioId: timid
        });
        if (data) {
          this.canEdit =
              !data.object.aa ||
              data.object.aa + "" == "0" ||
              data.object.aa + "" == "";
          this.selectedSira = data.object.kind;
          this.selectedTimoGroup = data.object.timo_group;
          // this.$router.replace({query: {kind: this.selectedSira}});
          this.$nextTick(() => {
            this.selectedInvoice = data.object;
            this.$refs.listedInvoices.brinkOnViewOrAppend(
                this.selectedInvoice,
                {
                  timologioId: this.selectedInvoice.timologioId
                }
            );
          });
          _log_("read....", this.selectedInvoice);
        }
      },
      deep: true,
      immediate: true
    }

  },
  async mounted() {
    _log_('mark resp:', this.selectedSira, this.$route.query.kind)
    if (this.$route.query.kind) this.selectedSira = this.$route.query.kind;
    const date = new Date();
    this.qRange = [date.getTime(),
                   date.getTime() + 3600 * 1000 * 24 * 91];
    // this.toggleDrawer(true);
    if (window.innerWidth > 901) this.heightWish = "50%";
    else this.heightWish = "50%";
    if (this.$mobileDevice) this.heightWish = "100%";
    if (this.userProfile && this.userProfile.invoiceGroups) {
      for (const key in this.userProfile.invoiceGroups) {
        if (this.userProfile.invoiceGroups.hasOwnProperty(key)) {
          this.selectedTimoGroup = this.userProfile.invoiceGroups[key];
          break;
        }
      }
    }
    this.loaded = true;

    // _log_("the rs///", this.userProfile);
  },
  methods: {
    // async cancelAadeMark(theMark, invDataPath) {//invDataPath=[errorType,invClass,invSira,invMark,invAA]
    //
    //   _log_('mark resp:', this.aadeReport, invDataPath)
    //   const {data} = await api.fetchProcessor("timologio/massissue", {
    //     do: 'cancelByMark',
    //     mark: theMark ? theMark : this.selectedMark
    //   });
    //
    //   if (data.results && data.results.aade.results[0].cancellationMark)
    //     if (invDataPath) this.$set(this.aadeReport.errors[invDataPath[0]][invDataPath[1]][invDataPath[2]][invDataPath[3]][invDataPath[4]], 'CancellationMark', data.results.aade.results[0].cancellationMark)
    //
    // },
    // async checkMark(mrk, extras = {}) {
    //   this.selectedMark = mrk
    //   this.aadeReport = null
    //   // this.loaded=false
    //   const {data} = await api.fetchProcessor("timologio/massissue", {
    //     do: 'check',
    //     mark: mrk, ...extras
    //   });
    //   if (data.results && data.results.aade)
    //     this.aadeReport = data.results.aade
    //
    //   _log_('mark resp:', data)
    // },
    async exportAADE(justThisInvoice) {
      this.processing = true
      this.aadeErrors = [];
      const qI = justThisInvoice
          ? {timologioId: this.selectedInvoice.timologioId}
          : {
            ...this.qInvoices,
            limit: 0
          };
      this.aadeMsgs =
          "Παρακαλώ περιμένετε τα μαγειρευουμε παρέα με την εφορεία";
      var {data} = await api.fetchProcessor("timologio/aade_bridge", qI);
      _log_("ore..D.", data);

      for (const invAade of data.results) {
        if (invAade.errors) {
          invAade.results.forEach(er => {
            this.aadeErrors.push({
              aa: er.invoiceObject ? er.invoiceObject.aa : er.aa,
              errors: er.errors
            });
          })
        }

        // _log_("ore..D.", invAade);
      }
      this.aadeMsgs =
          // this.dateFromUnxTime(this.unxnow(), true) +
          " στάλθηκαν " +
          data.results.length +
          " παραστατικα " +
          (!this.aadeErrors.length
              ? " oλα με επιτυχία"
              : " υπήρχαν " + this.aadeErrors.length + " αποτυχίες");
      if (justThisInvoice) {
        this.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          duration: !data.errors ? 3000 : 0,
          type: !this.aadeErrors.length ? 'success' : 'error',
          message: this.aadeMsgs //+ (! this.aadeErrors.length  ? '' : '<p>' + data.errors.join('<br/>') + '</p>')

        });
      }
      this.processing = false
      _log_('aadeErrors', this.aadeErrors)
      // data.results.forEach((res) => {});
    },
    exportEXCEL(what) {


      api.ajax_download("timologio/getlist", {...this.qInvoices, download: 1});
      //  {
      //   searchdaterange: this.dateRange,
      //   sira: this.selectedSira,
      //   timo_group: this.selectedTimoGroup
      // });
    },
    async displaySums() {
      this.selectedInvoice = {}
      var q = this.qInvoices;
      const d = await api.fetchProcessor("timologio/getlist", {
        ...q,
        mode: "sums_on_drafts",
        invoice_state: 1
      });
      _log_("ddd...", d.data.results);
      this.Sums = d.data.results;
      this.showSums = true;
    },
    moveTransactions() {
      if (this.selectedInvoiceToMoveTrans)
        this.selectedInvoiceToMoveTrans = null;
      else {
        this.selectedInvoiceToMoveTrans = this.selectedInvoice.timologioId;
        this.$notify({
          title: "Μετακινησε περιεχομενου παραστατικού",
          message:
              "Στην λίστα με τα παραστατικά δεξιά κάνε κλικ πάνω σε αυτό που θέλεις να μεταφέρεις το περιεχόμενο"
        });
      }
    },
    deleteInvoice() {
      const vm = this;
      this.$confirm("Θελεις να το διαγράψετε;", "ΠΡΟΣΟΧΗ!!!", {
            confirmButtonText: "Ναι",
            cancelButtonText: "Άστο καλήτερα",
            type: "warning",
            center: true
          })
          .then(async () => {
            var {data} = await api.removeObject(
                "timologio",
                vm.selectedInvoice
            );
            if (data.success)
              vm.removeArrayElement(
                  vm.listedInvoices,
                  vm.selectedInvoice,
                  "timologioId"
              );
            else
              vm.$message.error(
                  "Αυτο το παραστατικο δεν ειναι δυνατον να διαγραφεί"
              );

            _log_("r....", data);
          })
          .catch(() => {
          });
    },
    handlePayment() {
      const vm = this;
      // _log_(
      //   "tr.!!!!!!!!!!!!!!!!!.." + this.aggregators.costincl,
      //   this.selectedInvoice.costwithvat,
      //   Math.abs(
      //     parseFloat(this.selectedInvoice.costwithvat) +
      //       parseFloat(this.workingBusiness.balance)
      //   )
      // );
      if (vm.selectedInvoice.payed == 1) {
        this.$confirm("θελετε να ακυρώσετε την πληρωμή?", "! προσοχή", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            })
            .then(async () => {
              vm.selectedInvoice.payed = 0;

              vm.selectedInvoice.forcePayment = null;
              await vm.updateInvoice();
              // ++vm.clock;
            })
            .catch(() => {
            });
      }
      else {
        if (
            Math.abs(
                parseFloat(this.selectedInvoice.costwithvat) +
                parseFloat(this.workingBusiness.balance)
            ) > 0.01
        )
          this.$prompt(
                  "Ο συγκεκριμένος πελάτης" +
                  (this.workingBusiness.balance < 0
                      ? " χρωστάει "
                      : " του χρωστάμε ") +
                  this.$theMoney(this.workingBusiness.balance),
                  "Τι λεφτά μας έδωσε;",
                  {
                    confirmButtonText: "Πλήρωσε το παραπάνω ποσό",
                    cancelButtonText: "Ακυρω",
                    inputValue: this.$theMoney(this.selectedInvoice.costwithvat)
                  }
              )
              .then(async ({value}) => {
                vm.selectedInvoice.payed = 1;
                // _log_('pay...',value,this.$theMoney(value, true))
                vm.selectedInvoice.forcePayment = this.$theMoney(value, true);
                await vm.updateInvoice();
                // ++vm.clock;
              })
              .catch(() => {
              });
        else {
          vm.selectedInvoice.payed = 1;

          vm.selectedInvoice.forcePayment = this.selectedInvoice.costwithvat;
          vm.updateInvoice();
        }
      }
      // if(this.aggregators.costincl)
    },
    cancelInvoice() {
      const vm = this;
      if (this.selectedInvoice.aa && this.selectedInvoice.aa + "" != "0")
        this.$confirm(
                "Θελεις να το " +
                (vm.selectedInvoice.canceled != 1 ? "ακυρώσεις" : "επαναφερεις"),
                "ΠΡΟΣΟΧΗ!!!",
                {
                  confirmButtonText: "Ναι",
                  cancelButtonText: "Άστο καλήτερα",
                  type: "warning",
                  center: true
                }
            )
            .then(() => {
              vm.selectedInvoice.canceled =
                  vm.selectedInvoice.canceled == 1 ? 0 : 1;
              vm.updateInvoice({canceled: vm.selectedInvoice.canceled, timologioId: vm.selectedInvoice.timologioId});
            })
            .catch(() => {
            });
    },
    invoiceListClass(k) {
      var cls = "";
      if (this.selectedInvoiceToMoveTrans) cls += " wait ";
      if (k.row.canceled == 1) cls += " canceled-invoice";
      if (k.row.aa > 0) cls += " issued-invoice";
      else cls += " not-issued-invoice";
      return cls;
    },
    selectInvoiceState(k) {
      if (k == "gadgets") this.displaySums();
      else this.invoiceState = k;
    },
    updateCosts(transs) {
      // return
      // _log_("tr.!!!!!!!!!!!!!!!!!..", transs);
      const vm = this, this_is_draft_mode = this.transDraftsMode;
      vm.aggregators = {
        cost: 0.0,
        costincl: 0.0
      };
      transs.forEach(element => {
        if (this_is_draft_mode) {
          if (!isNaN(parseFloat(element.pretaxcost)))
            vm.aggregators.cost += parseFloat(element.pretaxcost);
          if (element.cost && !isNaN(parseFloat(element.cost)))
            vm.aggregators.costincl += parseFloat(element.cost);
          else if (element.vat && !isNaN(parseFloat(element.vat)))
            vm.aggregators.costincl += parseFloat(element.pretaxcost) * (parseFloat(element.vat) + 100) / 100;
        }
        else {
          if (!isNaN(parseFloat(element.cost)))
            vm.aggregators.cost += parseFloat(element.cost);
          if (element.costincl && !isNaN(parseFloat(element.costincl)))
            vm.aggregators.costincl += parseFloat(element.costincl);
          else if (element.vat && !isNaN(parseFloat(element.vat)))
            vm.aggregators.costincl += parseFloat(element.cost) * (parseFloat(element.vat) + 100) / 100;
        }
      });
      _log_("tr.!!!!!!!!!!!!AA!!!!!..", vm.aggregators);
      this.selectedInvoice.cost = vm.aggregators.cost;
      this.selectedInvoice.costwithvat = vm.aggregators.costincl;
      this.$refs.listedInvoices.updateRow(
          {timologioId: this.selectedInvoice.timologioId},
          this.selectedInvoice
      );
      // this.updateArrayElement(
      //   this.listedInvoices,
      //   this.selectedInvoice,
      //   "timologioId",
      //   true
      // );
    },
    async issueInvoice() {
      this.selectedInvoice.open = 0;
      this.selectedInvoice.editable = 0;
      const data = await this.updateInvoice();
      return data;
    },
    async updateInvoice(inv_data, silent) {
      _log_(
          "inv is..." + this.selectedInvoice.timologioId,
          this.selectedInvoice
      );
      if (!inv_data) inv_data = JSON.parse(JSON.stringify(this.selectedInvoice));
      if (!inv_data) return;
      try {
        inv_data.no_validation = true
        delete inv_data.aade_marks
        delete inv_data.aade_uid
        if (!inv_data.timo_group)
          inv_data.timo_group = this.selectedTimoGroup;
        if (!inv_data.kind)
          inv_data.kind = this.$route.query.kind
        if (!inv_data.date)
          inv_data.date = this.formatDate(new Date())
        const data = await api.updateProcessor("timologio/update", inv_data);
        if (!silent) {
          const reloadRoute = this.selectedInvoice.timologioId === null;
          this.selectedInvoice = data;
          // _log_("inv is...", this.selectedInvoice);
          // this.updateArrayElement(
          //   this.listedInvoices,
          //   this.selectedInvoice,
          //   "timologioId",
          //   true
          // );
          this.$refs.listedInvoices.updateRow(
              {timologioId: this.selectedInvoice.timologioId},
              this.selectedInvoice
          );
          if (reloadRoute) this.routeGo({
                name: "ManageInvoice",

                params: {
                  id: data.timologioId
                },

              }, true
          );
          // this.$router.push({
          //   name: "timologio",
          //
          //   params: {
          //     id: data.timologioId
          //   },
          //   query: this.$route.query
          // });
        }
        return data;
      }
      catch (e) {
        if (e.message && e.message.message)
          this.$notify.error({
            title: "Το παραστατικό δεν αποθηκεύτηκε!!!",
            message: e.message && e.message.message
          });
        return false;
      }
      return false;
    },
    newInvoice() {
      this.canEdit = true;
      // this.selectedInvoice = null;
      this.selectedInvoice = {
        timologioId: null,
        editable: 1,
        aa: 0,
        open: 1,
        date: format(new Date(), "DD/MM/YYYY"),
        vat: 24,
        kind: this.selectedSira
      };
      if (this.selectedTimoGroup)
        this.selectedInvoice.timo_group = this.selectedTimoGroup;
      //
      // this.$refs.listedInvoices.appendTrackedData(this.selectedInvoice, true);
      // _log_("hell..cccIII.", this.selectedInvoice);
      // this.listedInvoices.unshift(this.selectedInvoice);
      // this.$refs.listedInvoices.appendRecord(this.selectedInvoice)
    },
    toggleDrawer(v) {
      this.$refs.sidePanel.toggle(v);
    },
    async changeBusiness(e) {
      this.workingBusiness = e;
      _log_("hell..cccIII.", this.selectedInvoice);
      if (this.selectedInvoice.businessId != e.businessId) {
        this.selectedInvoice.businessId = e.businessId;
        if (this.selectedInvoice.aa) {
          if (
              confirm(
                  "Αυτο το παραστατικό έχει εκδωθεί απο της " +
                  this.selectedInvoice.date +
                  " πας να αλλάξεις τον πελάτη σύγουρα το θές?"
              )
          )
            await this.updateInvoice();
        }
        else await this.updateInvoice();
      }
      else {
        this.selectedInvoice.business_name = e.name;
        this.selectedInvoice.business_afm = e.afm;
        this.selectedInvoice.business_alias = e.alias;
        this.$refs.listedInvoices.updateRow(
            {timologioId: this.selectedInvoice.timologioId},
            this.selectedInvoice
        );
      }

      _log_("changed....", this.selectedInvoice);
      // if (this.selectedInvoice.nvoiceid) {
      //new

      // this.$refs.updateInvoices.appendRecord(this.selectedInvoice)

      // }
      // e=>(selectedInvoice.businessId=e.businessId)
    },
    handleContentFrame(pix) {
      if (this.$mobileDevice) {
        this.contentFrame = "width:100vw;";
        return;
      }
      if (pix === true) {
        this.drawerIsOpen = pix;
        pix = this.drawerWidth;
      }
      if (pix === false) {
        this.drawerIsOpen = pix;
        pix = 0;
      }
      // pix=700
      if (_.isNumber(pix)) {
        if (window.innerWidth - pix < 700) pix = 0;
        this.contentFrame = "width:calc(100vw - " + (pix + 3) + "px);";
      }
    },
    async copyInvoice() {
      var inv_data = this.selectedInvoice;
      if (!inv_data) return;
      try {
        const data = await api.updateProcessor("timologio/create", inv_data);

        if (data) {
          this.listedInvoices.unshift(data);
          this.$router.push({
            name: "timologio",

            params: {
              id: data.timologioId
            },
            query: this.$route.query
          });
        }
      }
      catch (e) {
        if (e.message && e.message.message)
          this.$notify.error({
            title: "Το παραστατικό δεν αποθηκεύτηκε!!!",
            message: e.message && e.message.message
          });
        return false;
      }
      return false;
    },
    loadInvoice(d) {
      this.selectedMark = null
      if (this.selectedInvoiceToMoveTrans) {
        const vm = this;
        this.$confirm(
                "Θελεις να το μεταφέρεις ολες τις κινησεις σε αυτό το παραστατικό;",
                "ΠΡΟΣΟΧΗ!!!",
                {
                  confirmButtonText: "Ναι",
                  cancelButtonText: "Άστο καλήτερα",
                  type: "warning",
                  center: true
                }
            )
            .then(async () => {
              var {data} = await api.fetchProcessor("gears/tools", {
                do: "move-trans",
                fromInv: vm.selectedInvoiceToMoveTrans,
                toInv: d.row.timologioId
              });
              vm.selectedInvoiceToMoveTrans = null;
              // _log_("r....", data);
            })
            .catch(() => {
            });
      }
      else {
        _log_("hell..ss.", d.row);
        this.routeGo({
              name: "ManageInvoice",

              params: {
                id: d.row.timologioId
              },

            }
        );
        // this.$router.push({
        //   name: "ManageInvoice",
        //   params: {
        //     id: d.row.timologioId
        //   },
        //   query: this.$route.query
        // });
        if (window.innerWidth < 900) this.toggleDrawer();
      }
      // this.canEdit = !d.row.aa || d.row.aa + "" == "0" || d.row.aa + "" == "";
      // this.selectedInvoice = d.row;
    },

    alert(msg) {
      _log_("hell...", msg);
    },
    setRange(dateOne, dateTwo) {
      this.qRange = [new Date(dateOne).getTime(),
                     new Date(dateTwo).getTime()];
    },
    formatDates() {
      const dateOne = this.qRange[0],
          dateTwo = this.qRange[1];
      // this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
      let formattedDates = "";
      if (dateOne && dateOne != "") {
        formattedDates = format(new Date(dateOne), this.dateFormat);
      }
      if (dateTwo && dateTwo != "") {
        formattedDates += " - " + format(new Date(dateTwo), this.dateFormat);
      }
      return formattedDates;
    },

    goToInvoice(data) {
      _log_("bokk,,,", data);
      window.open(
          "/invoices/&invoiceid=" +
          data.row.inv_timologioId +
          "&sira=" +
          data.row.inv_kind +
          "&timo_group=" +
          data.row.inv_timo_group,
          "_blank"
      );
      // this.$router.push({
      //   name: "EditBooking",
      //   query: { bkid: data.row.idBooking }
      // });
    }
  }
};
</script >

<style >
.invoice-details {
  background-color: #0a4e47;
}

.dark .el-tabs__item.is-active {
  color: aliceblue;
}

.dark .el-switch__label.is-active {
  color: rgb(232, 243, 232);
  font-weight: bold;
}

.dark .el-tabs__item {
  color: steelblue;
}

.dark .el-switch__label {
  color: rgb(103, 182, 143);
}

.search.x-row {
  align-items: flex-start;
}

.title {
  color: aliceblue;
  text-align: center;
}

.has-more {
  color: red;
  font-weight: 700;
}

div.el-radio-group.invoice-options {
  float: left;
  width: 100%;
}

.invoice-options.el-radio-group .el-radio-button {
  width: 33%;
}

.invoice-options.el-radio-group .el-radio-button .el-radio-button__inner {
  width: 100%;
}

.print_lang {
  font-size: 15px;
  line-height: 41px;
}

.wait {
  background-color: rgba(177, 173, 125, 0.329) !important;
}

.btn_left {
  display: flex;
}

.square_btn_left {
  flex: 2;
}

.round_btn_left {
  flex: 1;
}

div.stamp {
  width: 150px;
  float: right;
}

div.stamp * {
  padding: 2px;
  /*color: #095b69 !important;*/
  /*background-color: wheat !important;*/
}

/* .actions_btns .fa-cog {
  color: #ffffff;
} */
@media screen and (max-width: 1200px) {
  .btn_left {
    flex-direction: column;
    position: absolute;
    z-index: 1;
    padding: 15px;
    background: #095b69;
    border: #ffffff solid 1px;
    border-radius: 10px;
  }

  .square_btn_left {
    padding-bottom: 15px;
  }
}

.responsive-items button {
  padding: 9px !important;

}

@media screen and (max-width: 769px) {
  .responsive-items button {
    margin-left: 0px !important;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .square_btn_left {
    flex: 1;
  }

  .responsive-items {
    position: absolute;
    top: 35px;
    left: 0px;
    width: 100%;
    z-index: 1;
    background: #095b69;
    padding: 10px;
  }

  .round_btn_left {
    text-align: right;
  }
}
</style >
